'use client';

import React, { useState } from 'react';
import FAQItem from './FAQItem';
import SectionWrapper from '../SectionWrapper';
import { FAQ } from '@/actions/directus';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';

interface FAQBlockProps {
  faqs: FAQ[];
  withTitle?: boolean;
  invertedColors?: boolean;
  disableGutters?: boolean;
}

const FAQBlock: React.FC<FAQBlockProps> = ({
  faqs,
  withTitle = true,
  invertedColors = false,
  disableGutters = false,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const t = useTranslations();

  return (
    <SectionWrapper colored={false} disableGutters={disableGutters}>
      <div className="mx-auto max-w-7xl">
        {withTitle && (
          <h3 className="flex w-full items-center justify-center text-3xl font-medium">{t('FAQ_Title')}</h3>
        )}
        <div
          className={clsx(' mx-auto  w-full ', {
            'mt-8': !disableGutters,
          })}
        >
          {faqs.map((faq, index) => (
            <FAQItem
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              invertedColors={invertedColors}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default FAQBlock;
